import styled from 'styled-components';

export const TimeRangePickerFieldSC = styled.div`
  .content {
    display: flex;

    .icon {
      img {
        width: 20px;
        height: 20px;
      }
    }

    .picker-container {
      img {
        margin-left: 15px;
        margin-right: 5px;
      }
    }

    .rc-picker {
      background-color: white;
    }

    .rc-picker-input {
      width: 30px !important;
      max-width: 60px;
      border-bottom: 1px solid rgba(51, 61, 108, 1);

      input {
        padding: 4px;
      }
    }
  }

  .date-field {
    display: flex;
    align-items: center;
    color: rgba(51, 61, 108, 1);
    font-size: 14px;
  }
`;
